import React from 'react';
import ReactDOM from 'react-dom';
import getContentRoot from './utils/getContentRoot';
import AcuraNavigationManager from '../../components/AcuraNavigationManager';
import AcuraNavigationMobile from '../../components/AcuraNavigation/AcuraNavigation.mobile';
import Window from '../../components/Window';
import AcuraFooter from '../../components/AcuraFooter';

// Render the main app that controls navigation components and such
export function renderNavs(props) {
  return ReactDOM.render(
    <Window>
      <AcuraNavigationManager {...props}>
        <AcuraNavigationMobile {...props} />
      </AcuraNavigationManager>
    </Window>,
    getContentRoot('root')
  );
}

// Render the footer by itself wherever host supplies the DOM element
export function renderFooter(props) {
  return ReactDOM.render(
    <Window>
      <AcuraFooter menuItems={props.footerMenuItems} {...props} />
    </Window>,
    getContentRoot('footer')
  );
}



// WEBPACK FOOTER //
// ./src/apps/acuraca/mobile.layout.js